<template>
  <div v-bar class="pt-3 pl-3 pr-4 side-list">
    <ul class="px-2" @scroll="$emit('scroll', $event)">
      <li v-for="(item, index) in items"
          :id="`${idKey}${item[idKey]}`"
          :key="item[idKey]"
          :class="[{
                    'rounded-lg shadow-md bg-white': isItemSelected(item[idKey]),
                    'border-solid border-0 border-t border-gray-a10': displayTopBorder(index),
                    'bg-primary-light rounded-lg': hoverIndex === index
                  }, listClasses]"
          class="cursor-pointer"
          @click="$emit('item-selected',  item[idKey])"
          @mouseenter="hoverIndex = index"
          @mouseleave="hoverIndex = null"
      >
        <slot :isItemSelected="isItemSelected(item[idKey])" :item="item" name="item"/>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'SideList',

  props: {
    items: {
      type: Array,
      required: true
    },
    // e.g. 'contact_id', 'answer_id' etc
    idKey: {
      type: String,
      required: true
    },
    selectedId: {
      type: String,
      default: ''
    },
    listClasses: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      hoverIndex: null
    }
  },

  computed: {
    selectedIndex() {
      return this.items.findIndex(item => item[this.idKey] === this.selectedId)
    }
  },
  methods: {
    isItemSelected(itemId) {
      return this.selectedId === itemId
    },

    displayTopBorder(index) {
      if (this.selectedIndex === index - 1 || this.selectedIndex === index) return false

      return index !== 0
    }
  }
}
</script>

<style lang="scss">
.side-list {
  .vb-dragger {
    @apply min-h-12;
  }
}
</style>
